// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3A2-N","large":"styles_large__1NK1c"};